import React from 'react'
import { notAllowEnterNumber } from '../../assets/scripts/GeneralFunctions'

function SearchInput({ search_value, inputHandler, placeholder, isNumber = false }) {
  return (
    <>
      <div className="relative w-full max-w-[320px]">
        <input
          type={isNumber ? 'number' : 'text'}
          onKeyPress={(e) => {
            if (isNumber) {
              notAllowEnterNumber(e, 11)
            }
          }}
          value={search_value}
          onChange={inputHandler}
          id="simple-search"
          className={
            'h-11 bg-white border border-input-border text-gray-900 dark:border-slate-600 dark:bg-slate-800 dark:highlight-white/5 dark:hover:bg-slate-700 dark:text-amber-100 text-md rounded-md font-normal focus:ring-blue-500 focus:border-blue-500 block w-full p-3'
          }
          placeholder={placeholder}
          required
        />
      </div>

      <button
        type="submit"
        disabled={search_value.length === 0}
        className="h-11 py-2.5 px-5 mr-2 text-md font-semibold bg-main dark:bg-slate-600 rounded-md flex items-center border-0 focus:ring-4 focus:outline-none"
      >
        <span className={'hidden sm:block text-white pl-2'}>جستجو</span>
        <i className={'icon-search-normal text-white text-lg'} />
      </button>
    </>
  )
}

export default React.memo(SearchInput)
